var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-notification',{attrs:{"has-icon":true,"icon":"database","closable":false}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.$t('text'))}})]),_c('help-file-format')],1)}
var staticRenderFns = []

export { render, staticRenderFns }